import { render, staticRenderFns } from "./PeninsularIntro.vue?vue&type=template&id=ab0a7822&"
import script from "./PeninsularIntro.vue?vue&type=script&lang=js&"
export * from "./PeninsularIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports